var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHeader)?_c('div',{staticClass:"header-wrapper js-page-header",class:{
    fixed: _vm.fixHeader,
    'background-image': !!_vm.headerSettings.isBackgroundImage,
  }},[_c('Header',{attrs:{"isBackgroundImage":!!_vm.headerSettings.isBackgroundImage},on:{"scrollPosition":function($event){_vm.fixHeader = $event > 500}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }